module.exports = __webpack_public_path__ + "static/media/wifi.50db0087.png";